import React, { lazy } from "react";
import { ROLES, UserRole } from "src/constants/roles";

import { FeScheme, PAGES } from "src/types/navigation";

export const pagesRedirect: Record<UserRole, FeScheme> = {
  [ROLES.REGULAR]: [{scheme: PAGES.DASHBOARD}],
  [ROLES.ACCOUNTANT]: [{scheme: PAGES.DASHBOARD}]
};

export type PageRoute = {
  access: UserRole[];
  title: string;
  component: React.FC<any>;
  icon?: React.FC;
};
export type ModalRoute = PageRoute;

export const pages: Record<PAGES, PageRoute> = {
  [PAGES.ROOT]: {
    access: [],
    title: "Root",
    component: lazy(() => import("src/components/routes/pages/Root")),
  },

  [PAGES.VERIFY_EMAIL]: {
    access: [],
    title: "Verify Email",
    component: lazy(() => import("src/components/routes/pages/VerifyEmail/VerifyEmail")),
  },

  [PAGES.LOGIN]: {
    access: [],
    title: "Login",
    component: lazy(() => import("src/components/routes/pages/Login")),
  },
  [PAGES.REGISTER]: {
    access: [],
    title: "Create account",
    component: lazy(() => import("src/components/routes/pages/Register")),
  },
  [PAGES.CONFIRM_EMAIL]: {
    access: [],
    title: "Confirm email",
    component: lazy(() => import("src/components/routes/pages/EmailConfirmed")),
  },
  [PAGES.SELECT_ROLE]: {
    access: [],
    title: "Select role",
    component: lazy(() => import("src/components/routes/pages/SelectRole")),
  },
  [PAGES.RESET_PASSWORD]: {
    access: [],
    title: "Reset password",
    component: lazy(() => import("src/components/routes/pages/ResetPassword")),
  },
  [PAGES.RESET_EMAIL]: {
    access: [],
    title: "Reset email",
    component: lazy(
      () => import("src/components/routes/pages/ResetPasswordEmail")
    ),
  },
  [PAGES.CONFIRM_PASSWORD]: {
    access: [],
    title: "Confirm password",
    component: lazy(
      () => import("src/components/routes/pages/ConfirmPassword")
    ),
  },
  [PAGES.CONFIRM_RESET]: {
    access: [],
    title: "Confirm password changes",
    component: lazy(
      () => import("src/components/routes/pages/PasswordChangeSuccess")
    ),
  },
  [PAGES.DASHBOARD]: {
    access: [ROLES.REGULAR, ROLES.ACCOUNTANT],
    title: "Dashboard",
    component: lazy(() => import("src/components/routes/pages/Dashboard")),
  },
  [PAGES.RULE]: {
    access: [ROLES.REGULAR, ROLES.ACCOUNTANT],
    title: "Rule",
    component: lazy(() => import("src/components/routes/pages/Rule")),
  },
  [PAGES.REPORT]: {
    access: [ROLES.ACCOUNTANT, ROLES.REGULAR],
    title: "Report",
    component: lazy(() => import("src/components/routes/pages/ReportsPage")),
  },
  [PAGES.CLIENT_LIST]: {
    access: [ROLES.ACCOUNTANT],
    title: "Client list",
    component: lazy(() => import("src/components/routes/pages/ClientList")),
  },
  [PAGES.CLIENT_PAGE]: {
    access: [ROLES.ACCOUNTANT, ROLES.REGULAR],
    title: "Client page",
    component: lazy(() => import("src/components/routes/pages/ClientPage")),
  },
  [PAGES.PROFILE]: {
    access: [ROLES.REGULAR, ROLES.ACCOUNTANT],
    title: "Profile",
    component: lazy(() => import("src/components/routes/pages/Profile")),
  },
  [PAGES.ACCOUNTING]: {
    access: [ROLES.REGULAR, ROLES.ACCOUNTANT],
    title: "Accounting",
    component: lazy(() => import("src/components/routes/pages/Accounting")),
  },
  [PAGES.FIXED_ASSETS]: {
    access: [ROLES.REGULAR, ROLES.ACCOUNTANT],
    title: "Fixed assets",
    component: lazy(() => import("src/components/routes/pages/FixedAssets")),
  },
  [PAGES.LIABILITIES]: {
    access: [ROLES.REGULAR, ROLES.ACCOUNTANT],
    title: "Liabilities",
    component: lazy(() => import("src/components/routes/pages/Liabilities")),
  },
  [PAGES.PLAID_DONE]: {
    access: [],
    title: "Connect your bank",
    component: lazy(() => import("src/components/routes/pages/PlaidDone")),
  },
  [PAGES.PRIVACY]: {
    access: [],
    title: "Privacy Policy",
    component: lazy(() => import("src/components/routes/pages/PrivacyPolicy")),
  },
  [PAGES.CONNECT]: {
    access: [],
    title: "Connect your bank",
    component: lazy(() => import("src/components/routes/pages/Connect")),
  },
   // This item must be the last in the list
  [PAGES.ERROR_404]: {
    access: [],
    title: "Not found",
    component: lazy(() => import("src/components/routes/pages/Error404")),
  },
};
